import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { requestActions } from "./requestSlice"

export function useRequestActions() {
  const dispatch = useDispatch()
  return bindActionCreators(requestActions, dispatch)
}
